import { makeStyles, Theme } from '@material-ui/core';

export const useMenuStyles = makeStyles((theme) => ({
    menu: {
        display: 'grid',
        gridTemplateColumns: '1fr',
        gap: theme.spacing(2),
        width: '100%',
        [theme.breakpoints.up('lg')]: {
            gridTemplateColumns: '1fr 1fr',
        },
    },
}), { index: 1 });

export const useItemStyles = makeStyles((theme: Theme) => ({
    item: {
        minHeight: 106,
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderRadius: 16,
        padding: theme.spacing(3, 3),
        fontSize: theme.typography.h5.fontSize,
        backgroundColor: '#E9ECF5',
        lineHeight: 'initial',
        '&.MuiButton-root:hover': {
            backgroundColor: '#E9ECF5',
        },
        '&:not(:last-child)': {

        },
    },
    center: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        padding: theme.spacing(0, 2),
        overflow: 'hidden',
    },
    text: {
        textAlign: 'left',
        color: '#164781',
        fontWeight: 700,
    },
    description: {
        textAlign: 'left',
        fontSize: 16,
        color: theme.palette.text.secondary,
        whiteSpace: 'nowrap',
        overflowX: 'hidden',
        textOverflow: 'ellipsis',
    },
    icon: {
        color: '#98A2B3',
    },
}), { index: 1 });
